module.exports = __webpack_public_path__ + "fonts/iconfont.71a254e0.woff";